module.exports = __webpack_public_path__ + "img/scientificIcon05.22926000.png";